"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurHeartVision() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="222843" id="mission-vision" className="bg-background py-24 md:py-32 overflow-hidden" ref={sectionRef}>
      <div className="container mx-auto px-6 md:px-12 lg:px-24 max-w-7xl">
        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="relative w-full aspect-[4/5] lg:aspect-auto lg:h-[700px] rounded-3xl overflow-hidden shadow-2xl">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654300/img/community_mentorship_moment.png" alt="The Trust Foundation Community Mentorship" className="absolute inset-0 w-full h-full object-cover" />
            {}
            <div className="absolute inset-0 bg-secondary/10 mix-blend-overlay pointer-events-none"></div>
          </div>

          {}
          <div className="flex flex-col justify-center">
            <span className="text-sm font-medium tracking-widest uppercase text-secondary mb-6 font-default">
              Our Purpose
            </span>
            
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-semibold text-foreground mb-8 leading-tight">
              Restoring Dignity & Opportunity
            </h2>
            
            <div className="space-y-6 text-lg text-muted-foreground leading-relaxed font-default">
              <p>
                At The Trust Foundation, we believe that every individual deserves a pathway to stability and a second chance at a meaningful life. Our mission is to provide the essential supportive services and mentorship needed to restore dignity for those navigating the journey toward independence.
              </p>
              <p>
                We are a community-based nonprofit dedicated to more than just immediate relief; we are committed to long-term transformation. By integrating life skills development with comprehensive case management, we empower our participants to overcome barriers and reclaim their place as leaders in our community.
              </p>
              <p>
                Our vision is to create a future where every person has the resources to thrive, anchored by our core values of Truth, Responsibility, Understanding, Skills, and Thoughtfulness in every interaction and initiative we lead.
              </p>
            </div>

            <div className="mt-12 pt-8 border-t border-border/50">
              <div className="text-3xl md:text-4xl font-serif italic text-foreground/90">
                The Trust Foundation
              </div>
              <div className="text-sm text-muted-foreground mt-2 font-default tracking-wide">
                Building Pathways to Success
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}